import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Form from 'react-jsonschema-form';
import { Button, ButtonGroup } from 'react-bootstrap';
import { newDealerSchema } from './Schema';
import { newDealerUiSchema } from './uiSchema';
import { ProdigyMultiSchemaField } from '../ProdigyMultiSchemaField';
import './DealerEditor.scss';

export default class NewDealer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { formData: props.dealer };
  }

  onSubmit = ({ formData }) => {
    this.props.onCreate(formData);
  };

  validate = (formData, errors) => {
    // If the dealer is not independent, they must have a brand
    if (
      !formData.isIndependent &&
      (!formData.brand || formData.brand.length === 0)
    ) {
      errors.brand.addError('Please add a brand');
    }
    return errors;
  };

  render() {
    const { fetching, history } = this.props;
    return (
      <div className="dealer-editor-container">
        <Form
          schema={newDealerSchema}
          uiSchema={newDealerUiSchema}
          formData={this.state.formData}
          onSubmit={this.onSubmit}
          validate={this.validate}
          fields={{
            MultiSchemaField: ProdigyMultiSchemaField,
          }}
        >
          <ButtonGroup>
            <Button onClick={() => history.goBack()}>Cancel</Button>
            <Button
              bsClass="btn btn-primary btn-large"
              disabled={fetching}
              type="submit"
            >
              Submit
            </Button>
          </ButtonGroup>
        </Form>
      </div>
    );
  }
}

NewDealer.propTypes = {
  fetching: PropTypes.bool,
  dealer: PropTypes.object,
  history: PropTypes.object,
  onCreate: PropTypes.func,
};
